import { RegistryContext } from "@effect/atom-react";
import { AtomRegistry } from "effect/reactivity";
import { createElement, type PropsWithChildren, type ReactElement } from "react";

export const appAtomRegistry = AtomRegistry.make();

export function AppAtomRegistryProvider({ children }: PropsWithChildren): ReactElement {
  return createElement(RegistryContext.Provider, { value: appAtomRegistry }, children);
}
